<template>
  <v-dialog
    v-model="showModal"
    max-width="min(800px,70dvw)"
    height="100vh"
    content-class="d-flex justify-center"
    :aria-label="t(l.film.keyword_image)"
    @keydown.esc="showModal = false"
    @click:outside="showModal = false"
  >
    <v-card max-width="100%" min-height="100px" class="pa-4 rounded-lg d-flex justify-center">
      <DialogCloseButton variant="flat" color="white" @click="showModal = false" />
      <v-img min-width="100%" :src="imageUrl" :alt="t(l.film.keyword_image)" />
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useLocale } from '@/plugins/translation';
import { DialogCloseButton } from '@ilteducation/components';

const { t, l } = useLocale();

const showModal = defineModel({ default: false });
defineProps<{ imageUrl: string }>();
</script>

<style lang="scss" scoped>
.close-btn {
  position: absolute;
  right: 32px;
  top: 32px;
  z-index: 2;
  &:before {
    border-radius: 50%;
    background-color: white;
    opacity: 0.75;
  }
}
</style>
